// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__WXdT1","slogan":"styles_slogan__C5GRj","animate":"styles_animate__LGiHs"};